import React from 'react';

const InfoIcon: React.FC<{size?: number; color?: string}> = ({ size = 14, color = 'white' }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="10" cy="10" r="7" stroke={color} strokeWidth="1.8"/>
    <path d="M10 9V14" stroke={color} strokeWidth="1.8" strokeLinecap="round"/>
    <circle cx="10" cy="6.5" r="0.75" fill={color} stroke={color} strokeWidth="0.5"/>
  </svg>
);

export default InfoIcon;

